module.exports = "<h2 class=\"mb15\">Personal Profile</h2>\r\n<personal-information (onSave)=\"doNothing()\">loading...</personal-information>"


//////////////////
// WEBPACK FOOTER
// ./src/app/account/profile/profile.component.html
// module id = 720
// module chunks = 0